import { useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import API_URL from '../config/api';

export const useValidateDiscountCode = () => {
  return useMutation({
    mutationFn: async ({ code, subtotal }) => {
      const response = await axios.post(`${API_URL}/api/discount-codes/validate`, {
        code: code.toUpperCase(),
        subtotal
      });
      return response.data;
    }
  });
};

export const useCreateCheckoutSession = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const response = await axios.post(`${API_URL}/api/stripe/create-checkout-session`, payload);
      return response.data;
    }
  });
};

export const useCreateOrder = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const response = await axios.post(`${API_URL}/api/orders`, payload);
      return response.data;
    }
  });
};

export const usePublicShippingRates = () => {
  return useQuery({
    queryKey: ['shipping-rates', 'public'],
    queryFn: async () => {
      const response = await axios.get(`${API_URL}/api/shipping-rates/public`);
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
  });
};
